<template>
  <div class="Inicio">
    <div class="banner_dvw">
      <div class="banner_dv1">
        <img class="banner_1img" src="@/assets/img/banner_1.webp" alt="">
      </div>
    </div>
    <div class="jgq_dvw">
      <div class="jgq_dv1">
        <img src="@/assets/img/jgq_2.webp" alt="">
      </div>
    </div>

    <div class="section_dvw">
      <div class="section_dv1">
        <div class="section_1img">
          <img src="@/assets/img/section_01.png" alt="">
        </div>
        <div class="section_vtext1">
          <div class="section_vt1_head">Comentarios</div>
          <div class="section_vt1_p">Recogemos las opiniones más reales y efectivas de nuestros usuarios</div>
          <div class="section_vt1_p">para poder corregir y mejorar nuestro servicio</div>
        </div>
      </div>
    </div>

    <div class="pj_dvw">
      <div class="pj_dv1">
        <img src="@/assets/img/pj_001.webp" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import "./scss/Inicio.scss";

export default {
  name: "Inicio",
  data() {
    return {

    };
  },
  created() {

  },
  methods: {

  },
};
</script>

<style lang="scss">
  .banner_dvw{
    width: 100%;
    height: 759px;
    background: #0F0000;
    box-sizing: border-box;
    padding: 76px 0 0 0;
  }
  .banner_dv1{
    width: 1074px;
    height: 494px;
    margin: 0 auto;
    .banner_1img{
      display: block;
      width: 1074px;
      height: 494px;
    }
  }
  .jgq_dvw{
    width: 100%;
    height: 347px;
    background: #0F0000;
    .jgq_dv1{
      width: 1300px;
      height: 240px;
      margin: 0 auto;
      img{
        display: block;
        width: 100%;
        height: 240px;
      }
    }
  }
  .section_dvw{
    width: 100%;
    height: 1415px;
    background: #0F0000;
    .section_dv1{
      width: 1440px;
      height: 1415px;
      margin: 0 auto;
      overflow: hidden;
      position: relative;
      .section_1img{
        width: 2321px;
        height: 2022px;
        position: absolute;
        left: 0;
        top: 0;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .section_vtext1{
        width: 100%;
        height: 206px;
        position: absolute;
        left: 0;
        bottom: 0;
        .section_vt1_head{
          width: 100%;
          height: 56px;
          font-weight: bold;
          font-size: 48px;
          color: #FFFFFF;
          line-height: 56px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          padding-bottom: 24px;
        }
        .section_vt1_p{
          width: 100%;
          font-weight: 400;
          font-size: 16px;
          color: #808187;
          line-height: 24px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
      }
    }
  }
  .pj_dvw{
    width: 100%;
    height: 759px;
    background: #0F0000;
    .pj_dv1{
      width: 1488px;
      height: 472px;
      margin: 0 auto;
      img {
        display: block;
        width: 100%;
        height: 472px;
      }
    }
  }
</style>
